import React, { useEffect, useState } from "react";

import CustomObjectFieldTabs from "../raffle/CustomObjectFieldTabs"
import { Form } from "@rjsf/mui"
import { IChangeEvent } from "@rjsf/core"
import { RJSFSchema } from "@rjsf/utils"
import { useAppConfiguration } from "../AppConfigurationService"
import validator from "@rjsf/validator-ajv8"
import { LoadingService } from "react-ui-components/components/LoadingService";
import { PopupService } from "react-ui-components/components/PopupService";
import { DateTimeWidget } from "../CustomWidgets";
import {
  displayContentConfigSchema,
  displayContentConfigUiSchema,
} from "./displayContentConfigSchema"

// function CountryUIWidget({ onChange, ...rest }: any) {
//   function onHandleChange(_name: string, value: any) {
//     onChange(value)
//   }
//   return (
//     <LocationProvider {...rest}>
//       <CountryLocationSelector {...rest} onChange={onHandleChange} />
//     </LocationProvider>
//   )
// }

export function DisplayContentConfig() {
  const { saveConfig, configuration } = useAppConfiguration()

  const [configData, setConfigData] = useState(configuration)

  useEffect(() => {
    setConfigData(configuration)
  }, [configuration])

  const onSubmit = async ({ formData }: IChangeEvent<any, RJSFSchema, any>) => {
    try {
      LoadingService.show()
      if (!formData) {
        return "No data to save"
      }
      await saveConfig(formData)
    } catch (error: any) {
      console.log("Error saving configuration: ", formData)
      PopupService.pushPopup(error.message)
    } finally {
      LoadingService.hide()
    }
  }

  return (
    <Form
      formData={configData}
      // fields={{ LocationProvider }}
      widgets={{ DateTimeWidget }}
      schema={displayContentConfigSchema}
      uiSchema={displayContentConfigUiSchema}
      validator={validator}
      onSubmit={onSubmit}
      // onError={(error) => onError && onError(error)}
      templates={{
        ObjectFieldTemplate: CustomObjectFieldTabs,
      }}
      formContext={{ className: "m-5" }}
    />
  )
}
